if(!customElements.get('magora-cart')){customElements.define('magora-cart',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;
        const root=window.Shopify?.routes?.root || '/';
        const giftId=Number(this.dataset.giftVariant);
        const protectionId=Number(this.dataset.protectionVariant);
        const mainId=Number(this.dataset.mainVariant);
        const cartLayer=this.querySelector('[data-cart-layer]');
        const cartDrawer=this.querySelector('.mx-cart-drawer');
        const cartContent=this.querySelector('[data-cart-content]');
        const money=(cents)=>new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:this.dataset.localCurrency || window.Shopify?.currency?.active || 'USD'}).format((cents || 0)/100);
        const esc=(value)=>String(value ?? '').replace(/[&<>'"]/g,character=>({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[character]));
        const requestCart=async(path,options={})=>{
          const response=await fetch(root+path,{headers:{Accept:'application/json','Content-Type':'application/json'},...options});
          const result=await response.json();
          if(!response.ok) throw new Error(result.description || result.message || 'Unable to update your bag. Please try again.');
          return result;
        };
        const fetchCart=()=>requestCart('cart.js');
        const closeCart=()=>{
          cartLayer.hidden=true;
          cartLayer.setAttribute('aria-hidden','true');
          document.documentElement.style.overflow='';
          this.returnFocus?.focus({preventScroll:true});
          document.querySelectorAll('[data-magora-cart-open]').forEach(el=>el.setAttribute('aria-expanded','false'));
        };
        const openCart=()=>{
          cartLayer.hidden=false;
          cartLayer.setAttribute('aria-hidden','false');
          document.documentElement.style.overflow='hidden';
          document.querySelectorAll('[data-magora-cart-open]').forEach(el=>el.setAttribute('aria-expanded','true'));
          requestAnimationFrame(()=>cartDrawer.focus({preventScroll:true}));
        };
        const renderCart=(cart,note='')=>{
          const regular=cart.items.filter(item=>item.id!==giftId && item.id!==protectionId);
          const gift=cart.items.find(item=>item.id===giftId);
          const protection=cart.items.find(item=>item.id===protectionId);
          const itemCount=regular.reduce((sum,item)=>sum+item.quantity,0);
          const saved=regular.reduce((sum,item)=>sum+Math.max(0,(item.original_line_price || 0)-(item.final_line_price ?? item.line_price ?? 0)),0);
          this.querySelector('[data-cart-count]').textContent=itemCount;
          this.querySelector('[data-cart-total]').textContent=money(cart.total_price);
          const savingsRow=this.querySelector('[data-cart-savings-row]');
          savingsRow.hidden=saved<=0;
          this.querySelector('[data-cart-savings]').textContent=saved>0?'- '+money(saved):'';
          const lines=regular.map(item=>{
            const finalPrice=item.final_line_price ?? item.line_price;
            const originalPrice=item.original_line_price ?? finalPrice;
            const image=item.image || this.dataset.productImage;
            return `<article class="mx-cart-line"><img src="${esc(image)}" width="164" height="164" alt=""><div class="mx-cart-line-copy"><div class="mx-cart-line-title"><b>${esc(item.product_title || item.title)}</b><span class="mx-cart-line-price">${originalPrice>finalPrice?`<s>${money(originalPrice)}</s>`:''}<strong>${money(finalPrice)}</strong></span></div>${originalPrice>finalPrice?`<p class="mx-cart-save">You save ${money(originalPrice-finalPrice)}</p>`:''}<div class="mx-cart-qty" aria-label="Quantity"><button type="button" data-cart-quantity="${item.quantity-1}" data-cart-key="${esc(item.key)}" aria-label="Decrease quantity">−</button><span>${item.quantity}</span><button type="button" data-cart-quantity="${item.quantity+1}" data-cart-key="${esc(item.key)}" aria-label="Increase quantity">+</button></div></div></article>`;
          }).join('');
          const tripEntered=regular.some(item=>item.properties?.['Dream Trip Giveaway']==='Entered');
          const tripBlock=itemCount>0 && tripEntered?`<section class="mx-unlock"><h3>Congrats! You unlocked a free gift!🎉</h3><div class="mx-unlock-row"><img src="${esc(this.dataset.tripImage)}" width="104" height="104" alt="Dream trip"><div><b>Chance to Win a $2,500 Dream Trip</b><span>FREE</span></div></div></section>`:'';
          const giftBlock=itemCount>0 && gift?`<section class="mx-unlock"><h3>Congrats! Your free guide is unlocked!🎉</h3><div class="mx-unlock-row"><img class="mx-ebook-cover" src="https://cdn.shopify.com/s/files/1/0848/6856/3197/files/magora-ebook-cover-v1.png?v=1792515467&width=160" width="64" height="64" alt="Magora Copper Vitality Ritual ebook"><div><b>The 7-Day Copper Vitality Ritual (100% off)</b><span>FREE</span></div><strong class="mx-unlock-badge">✓</strong></div></section>`:'';
          const protectionBlock=itemCount>0?`<section class="mx-protection"><span class="mx-protection-icon" aria-hidden="true"><svg viewBox="0 0 36 40"><path d="M18 2 32 7v10c0 10-5.7 17.2-14 21C9.7 34.2 4 27 4 17V7Z"></path><path d="m11 20 4 4 10-11"></path></svg></span><div class="mx-protection-copy"><b>Shipping Protection</b><p>Protect your order from damage, loss or theft during shipping.</p></div><div class="mx-protection-actions"><b>${money(protection?.final_line_price ?? Number(this.dataset.protectionPrice))}</b><label class="mx-switch"><input type="checkbox" data-protection-toggle ${protection?'checked':''} aria-label="Add shipping protection for ${money(protection?.final_line_price ?? Number(this.dataset.protectionPrice))}"><i></i></label></div></section>`:'';
          cartContent.innerHTML=regular.length?lines+tripBlock+giftBlock+protectionBlock+(note?`<p class="mx-cart-note">${esc(note)}</p>`:''):'<div class="mx-cart-empty"><p>Your bag is empty.</p></div>';
          this.querySelector('.mx-cart-foot').hidden=!regular.length;
          this.querySelector('.mx-cart-reserve').hidden=!regular.length;
          this.querySelector('.mx-cart-shipping').hidden=!regular.length;
          openCart();
        };
        const ensureExtras=async()=>{
          let cart=await fetchCart();
          const additions=[];
          if(!cart.items.some(item=>item.id===giftId)) additions.push({id:giftId,quantity:1});
          if(!this.protectionOptOut && !cart.items.some(item=>item.id===protectionId)) additions.push({id:protectionId,quantity:1});
          if(additions.length){
            try{
              await requestCart('cart/add.js',{method:'POST',body:JSON.stringify({items:additions})});
              cart=await fetchCart();
            }catch(error){
              return {cart,note:'The complimentary guide or shipping protection could not be added. Please refresh and try again.'};
            }
          }
          return {cart,note:''};
        };
        this.querySelectorAll('[data-cart-close]').forEach(close=>close.addEventListener('click',closeCart));
        document.addEventListener('keydown',event=>{if(event.key==='Escape' && !cartLayer.hidden) closeCart();});
        cartContent.addEventListener('click',async event=>{
          const control=event.target.closest('[data-cart-quantity]');
          if(!control) return;
          control.disabled=true;
          try{
            const cart=await requestCart('cart/change.js',{method:'POST',body:JSON.stringify({id:control.dataset.cartKey,quantity:Number(control.dataset.cartQuantity)})});
            renderCart(cart);
          }catch(error){
            control.disabled=false;
            cartContent.insertAdjacentHTML('beforeend',`<p class="mx-cart-note">${esc(error.message)}</p>`);
          }
        });
        cartContent.addEventListener('change',async event=>{
          const toggle=event.target.closest('[data-protection-toggle]');
          if(!toggle) return;
          toggle.disabled=true;
          try{
            let cart=await fetchCart();
            const current=cart.items.find(item=>item.id===protectionId);
            this.protectionOptOut=!toggle.checked;
            if(toggle.checked && !current) await requestCart('cart/add.js',{method:'POST',body:JSON.stringify({items:[{id:protectionId,quantity:1}]})});
            if(!toggle.checked && current) await requestCart('cart/change.js',{method:'POST',body:JSON.stringify({id:current.key,quantity:0})});
            cart=await fetchCart();
            renderCart(cart);
          }catch(error){
            toggle.checked=!toggle.checked;
            toggle.disabled=false;
            cartContent.insertAdjacentHTML('beforeend',`<p class="mx-cart-note">${esc(error.message)}</p>`);
          }
        });

        this.show=async(trigger)=>{
          this.returnFocus=trigger || document.activeElement;
          cartContent.innerHTML='<p class="mx-cart-note">Loading your bag...</p>';
          this.querySelector('.mx-cart-foot').hidden=true;
          openCart();
          try { renderCart(await fetchCart()); }
          catch(error){ cartContent.innerHTML=`<p class="mx-cart-note">${esc(error.message)}</p><button type="button" class="mx-cart-retry" data-cart-retry>Try again</button>`; }
        };
        this.add=async(item,trigger)=>{
          this.returnFocus=trigger || document.activeElement;
          await requestCart('cart/add.js',{method:'POST',body:JSON.stringify({items:[item]})});
          const {cart,note}=await ensureExtras();
          renderCart(cart,note);
        };
        document.addEventListener('click',event=>{
          const trigger=event.target.closest('[data-magora-cart-open],a[href="'+root+'cart"]');
          if(!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();event.stopImmediatePropagation();this.show(trigger);
        },true);
        cartContent.addEventListener('click',event=>{if(event.target.closest('[data-cart-retry]'))this.show(this.returnFocus);});
        cartDrawer.addEventListener('keydown',event=>{
          if(event.key!=='Tab')return;
          const focusable=[...cartDrawer.querySelectorAll('button:not([disabled]),a[href],input:not([disabled])')].filter(el=>el.getClientRects().length);
          const first=focusable[0],last=focusable.at(-1);
          if(event.shiftKey && (document.activeElement===first || document.activeElement===cartDrawer)){event.preventDefault();last?.focus();}
          else if(!event.shiftKey && document.activeElement===last){event.preventDefault();first?.focus();}
        });

}});}
